<template>
  <div class="qrcode-box">
    <p class="code-tips" :style="qrText" v-html="letter.qrCodeTip"></p>
    <img :src="qrcodeSrc" class="code" @click="updateCodeState" />
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { QR_CODE_AJAX, PASSPORT_HOST } from "../store/web/h5";

// 二维码每隔5分钟自动刷新一次
// 点击刷新

export default {
  data() {
    return {
      loadCode: true,
      qrText: `color:${window.pageInfo.color.font}`,
    };
  },
  computed: {
    qrcodeSrc() {
      if (this.loadCode) {
        let timesmap = new Date().getTime();
        return `${PASSPORT_HOST}${QR_CODE_AJAX}?${window.location.search.substr(
          1
        )}&game_id=${this.gameId}&v=${timesmap}`;
      } else {
        return "";
      }
    },
    ...mapGetters(["letter", "accountId", "gameId"]),
  },
  watch: {
    loadCode(newValue) {
      if (!newValue) {
        this.$nextTick(() => {
          this.updateCodeState();
        });
      }
    },
    accountId(newValue, oldVal) {
      if (newValue !== oldVal) {
        this.$nextTick(() => {
          this.updateCodeState();
        });
      }
    },
  },
  created() {
    setInterval(() => {
      this.loadCode = false;
    }, 1000 * 60 * 5);
  },
  methods: {
    updateCodeState() {
      this.loadCode = !this.loadCode;
    },
  },
};
</script>
